export default __webpack_public_path__ + "static/media/load.2ebc8862.gif";